import { Button } from "@/overlay/components/CommonParts/buttons";
import type { WeatherPlotSeries } from "@/reducer/client-models";
import { classNames } from "@/utility/jsx";
import { t } from "@lingui/core/macro";
import { type PropsWithChildren, useState } from "react";

type PlotSeriesHeaderProps = {
  plotSeries: WeatherPlotSeries;
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  onUpdateSerie: (plotSerie: Partial<WeatherPlotSeries>) => void;
};

export function PlotSeriesHeader({ isOpen, setIsOpen, plotSeries, onUpdateSerie }: PlotSeriesHeaderProps) {
  const toggle = () => setIsOpen(!isOpen);
  // @ts-ignore
  const isVisible = plotSeries.visible === undefined ? !!plotSeries.show : plotSeries.visible;
  return (
    <div className={`expansion-panel__header ${!isVisible ? "hidden" : ""}`}>
      <div className="expansion-panel__header__layer-info" onClick={toggle}>
        <span className="expansion-panel__chevron">
          <span className="material-icons">{isOpen ? "expand_less" : "expand_more"}</span>
        </span>
        <span className="layer-label">
          <span className="layer-label__kindName tag">{plotSeries.series_type} </span>
          <span className="layer-label__kindName">
            <span className="layer-label__kindName layer-label__kindName--parameter">{plotSeries.parameter_unit}</span>
          </span>
        </span>
      </div>
      <div className="expansion-panel__header__right-control">
        <mm-tooltip-wrapper tail={true} position="top" tooltip-text={!isVisible ? t`Show` : t`Hide`}>
          <Button
            type="button"
            icon={isVisible ? "visibility" : "visibility_off"}
            onClick={() => onUpdateSerie({ visible: !isVisible })} // use .visible
          />
        </mm-tooltip-wrapper>
      </div>
    </div>
  );
}

type PlotSeriesProps = {
  plotSeries: WeatherPlotSeries;
  onUpdateSerie: (plotSerie: Partial<WeatherPlotSeries>) => void;
};

export function PlotSeriesPanel({ plotSeries, onUpdateSerie, children }: PropsWithChildren<PlotSeriesProps>) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={classNames("expansion-panel box-section--breakout actionable", isOpen && "expansion-panel--expanded")}
      key={plotSeries.index}
    >
      <div className="box-section--breakout">
        <PlotSeriesHeader plotSeries={plotSeries} isOpen={isOpen} setIsOpen={setIsOpen} onUpdateSerie={onUpdateSerie} />
        {isOpen && (
          <div>
            <div className="expansion-panel__content">{children}</div>
          </div>
        )}
      </div>
    </div>
  );
}
